<keycloak-auth-manager-kam-role-selection    
    [initialRolesSelected]="initialRolesSelected"
    (roleSelection)="rolesSubscriptionUpdate($event)"> 

</keycloak-auth-manager-kam-role-selection>

<div style="text-align: center" >
    <button mat-button matStepperPrevious>{{"KAM-GENERAL-DIALOG.BACK" |translate}}</button>
    <button mat-button matStepperNext (click)="step4End()">{{"KAM-GENERAL-DIALOG.NEXT" |translate}}</button>
</div>